// dataQualityRows.js - the pure Control/Result row builder for the data-quality figure, shared by
// the printed DataQualityBlock and the inspector's "Data behind this" data-quality panel
// (inspector/figureDataPanels.jsx) so both surfaces render byte-identical rows. Kept dependency-free
// (only format.js, itself pure) so the panel can import it without dragging in useBlockData/keycloak.
import { humanEUR, fmtDate } from "./format";

// fmtPct1 renders a 0..1 fraction as a one-decimal percentage (0.964 -> "96.4%"). money.js's
// whole-number pct() would round 96.4%/95.6% into an indistinguishable "96%" on a table whose whole
// purpose is auditing precision.
export function fmtPct1(frac) {
  if (frac == null || Number.isNaN(Number(frac))) return "—";
  return `${(Number(frac) * 100).toFixed(1)}%`;
}

// CONFIDENCE_LABEL maps boardfigures.QualityInput.ForecastConfidence's vocabulary
// ("high" | "medium" | "low" | "not_yet_rated") onto a display label.
const CONFIDENCE_LABEL = { high: "High", medium: "Medium", low: "Low", not_yet_rated: "Not yet rated" };

export function confidenceLabel(level) {
  return CONFIDENCE_LABEL[level] || level || "—";
}

// buildRows maps DataQuality (internal/boardfigures/quality.go's BuildDataQuality) onto the
// Control/Result rows the appendix's control-summary table shows. The backend provides no per-field
// status/tone, so this renders Control + Result only - no invented verdicts.
export function buildRows(dq) {
  return [
    {
      id: "coverage",
      control: "Spend allocated to accountable owners",
      result: fmtPct1(dq.allocation_coverage_pct),
    },
    {
      id: "estimated",
      control: "Estimated rather than invoiced cost",
      // estimated_available is false whenever no whole-project estimated-vs-invoiced signal exists.
      // Rendering "0%" would misleadingly read as "everything is confirmed" rather than "unknown".
      result: dq.estimated_available ? `${Number(dq.estimated_pct).toFixed(1)}%` : "n/a",
    },
    {
      id: "confidence",
      control: "Forecast confidence",
      result: confidenceLabel(dq.forecast_confidence),
    },
    {
      id: "variance",
      control: "Unexplained monthly variance",
      result: humanEUR(dq.unexplained_variance),
    },
    {
      id: "complete_through",
      control: "Data complete through",
      result: fmtDate(dq.data_complete_through),
    },
  ];
}
